import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import { getCoachSessionReport, getSessionReport } from "../../../../services/ReportService";

const theadData = [
    { heading: "S.No", sortingVale: "sno" },
    { heading: "Name", sortingVale: "name" },
    { heading: "Session Type", sortingVale: "sessionName" },
    { heading: "Start Time", sortingVale: "startDate" },
    { heading: "End Time", sortingVale: "endDate" },
    { heading: "Effective Date", sortingVale: "effectiveDate" },
    { heading: "Comment", sortingVale: "comment" },
    { heading: "Status", sortingVale: "status" },
];

const SessionReports = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState([]);

    // pagination & search
    const [page, setPage] = useState(0); // 0-based
    const [size, setSize] = useState(10); // page size
    const [search, setSearch] = useState(""); // search text
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentStart, setCurrentStart] = useState(0);

    //filter

    const [open, setOpen] = useState(true);
    const [status, setStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [iconData, setIconDate] = useState({ complete: false, ind: Number });

    // ---- API CALL WITH page, size, search ----
    async function fetchUserData({ page, size, search, selectedStatus }) {
        setLoading(true);
        try {
            const res = await getCoachSessionReport(page, size, search, selectedStatus);
            setUserData(res?.content || []);
            setTotalElements(res?.totalElements || 0);
            setTotalPages(res?.totalPages || 0);
            setCurrentStart(res?.number || 0);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoading(false);
        }
    }

    // initial & whenever page/size/search changes
    useEffect(() => {
        fetchUserData({
            page,
            size,
            search,
            selectedStatus,
        });
    }, [page, size, search, selectedStatus]);

    // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
    function SotingData(name) {
        const sortedPeople = [...userData];
        switch (name) {
            case "name":
                sortedPeople.sort((a, b) =>
                    iconData.complete
                        ? a.name.localeCompare(b.name)
                        : b.name.localeCompare(a.name),
                );
                break;

            case "email":
                sortedPeople.sort((a, b) =>
                    iconData.complete
                        ? a.name.localeCompare(b.name)
                        : b.name.localeCompare(a.name),
                );
                break;

            case "landLine":
                sortedPeople.sort((a, b) =>
                    iconData.complete
                        ? (a.landLine || "").localeCompare(b.landLine || "")
                        : (b.landLine || "").localeCompare(a.landLine || ""),
                );
                break;

            case "phone":
                sortedPeople.sort((a, b) =>
                    iconData.complete
                        ? (a.phone || "").localeCompare(b.phone || "")
                        : (b.phone || "").localeCompare(a.phone || ""),
                );
                break;

            default:
                break;
        }
        setUserData(sortedPeople);
    }

    // ---- Search handler ----
    function handleSearchChange(e) {
        const value = e.target.value;
        setSearch(value);
        setPage(0); // reset to first page on search
    }

    const downloadExcel = async () => {
        try {
            const res = await getCoachSessionReport(0, 1000, search, selectedStatus);

            const formattedData = (res?.content || []).map((data, index) => ({
                "S.No": index + 1,
                Name: data?.name,
                "Session Type": data?.sessionType?.name,
                "Start Date": data?.startTime,
                "End Date": data?.endTime,
                "Effective Date": data?.effectiveDate,
                Comment: data?.comment,
                Status: data?.status,
            }));

            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const file = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            saveAs(file, "session-reports.xlsx");
        } catch (error) {
            console.error("Excel download failed:", error);
        }
    };

    const statusData = [
        { id: "ACTIVE", name: "Active" },
        { id: "INACTIVE", name: "Inactive" },
    ];

    return (
        <>
            <PageTitle activeMenu={"Session Reports"} motherMenu={"Reports"} />
            <div className="filter cm-content-box box-primary">
                <div className={`content-title`} onClick={() => setOpen(!open)}>
                    <div className="cpa">
                        <i className="fas fa-filter me-2"></i>Filter
                    </div>
                    <div className="tools">
                        <Link
                            to={"#"}
                            className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                        >
                            <i className="fas fa-angle-up"></i>
                        </Link>
                    </div>
                </div>
                <Collapse in={open}>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-3">
                                    <label className="form-label">Status</label>
                                    <Select
                                        isSearchable={false}
                                        options={[
                                            { value: "", label: "All Status" },
                                            ...(statusData || []).map((status) => ({
                                                value: status?.id,
                                                label: `${status?.name}`,
                                            })),
                                        ]}
                                        className="custom-react-select"
                                        onChange={(option) =>
                                            setSelectedStatus(option?.value || null)
                                        }
                                        placeholder="Select Status"
                                    />
                                </div>
                                <div className="col-xl-3 d-flex align-items-end">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        style={{ height: "2.8rem" }}
                                        onClick={downloadExcel}
                                    >
                                        <i className="fas fa-file-excel me-2"></i> Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            <Row>
                <Tab.Container defaultActiveKey={"List"}>
                    <div className="col-lg-12">
                        <Tab.Content className="row tab-content">
                            {/* LIST VIEW */}
                            <Tab.Pane eventKey="List" className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="dataTables_wrapper no-footer">
                                            <div className="justify-content-between d-sm-flex mb-3">
                                                {/* PAGE SIZE DROPDOWN */}
                                                <div className="dataTables_length">
                                                    <label className="d-flex align-items-center">
                                                        Show
                                                        <Dropdown className="search-drop ms-2 me-2">
                                                            <Dropdown.Toggle
                                                                as="div"
                                                                className="search-drop-btn"
                                                            >
                                                                {size}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[10, 20, 30].map((val) => (
                                                                    <Dropdown.Item
                                                                        key={val}
                                                                        onClick={() => {
                                                                            setSize(val);
                                                                            setPage(0);
                                                                        }}
                                                                    >
                                                                        {val}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        entries
                                                    </label>
                                                </div>

                                                {/* SEARCH */}
                                                <div className="dataTables_filter">
                                                    <label>
                                                        Search :{" "}
                                                        <input
                                                            type="search"
                                                            className=""
                                                            placeholder=""
                                                            value={search}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </label>
                                                </div>
                                            </div>

                                            {/* TABLE WITH HORIZONTAL SCROLL */}
                                            <div className="table-responsive">
                                                <table
                                                    id="example4"
                                                    className="display dataTable no-footer w-100"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {theadData.map((item, ind) => (
                                                                <th
                                                                    key={ind}
                                                                    onClick={() => {
                                                                        if (item.sortingVale === "action") return;
                                                                        SotingData(item.sortingVale);
                                                                        setIconDate((prevState) => ({
                                                                            complete: !prevState.complete,
                                                                            ind: ind,
                                                                        }));
                                                                    }}
                                                                    style={
                                                                        item.sortingVale !== "action"
                                                                            ? { cursor: "pointer" }
                                                                            : {}
                                                                    }
                                                                >
                                                                    {item.heading}
                                                                    {item.sortingVale !== "action" && (
                                                                        <span>
                                                                            {ind !== iconData.ind && (
                                                                                <i
                                                                                    className="fa fa-sort ms-2 fs-12"
                                                                                    style={{ opacity: "0.3" }}
                                                                                />
                                                                            )}
                                                                            {ind === iconData.ind &&
                                                                                (iconData.complete ? (
                                                                                    <i
                                                                                        className="fa fa-arrow-down ms-2 fs-12"
                                                                                        style={{ opacity: "0.7" }}
                                                                                    />
                                                                                ) : (
                                                                                    <i
                                                                                        className="fa fa-arrow-up ms-2 fs-12"
                                                                                        style={{ opacity: "0.7" }}
                                                                                    />
                                                                                ))}
                                                                        </span>
                                                                    )}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!loading &&
                                                            userData.map((data, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{currentStart * size + ind + 1}</td>
                                                                    <td>{data?.name}</td>
                                                                    <td>{data?.sessionType?.name}</td>
                                                                    <td>{data?.startTime}</td>
                                                                    <td>{data?.endTime}</td>
                                                                    <td>{data?.effectiveDate}</td>
                                                                    <td>{data?.comment}</td>
                                                                    <td>{data?.status}</td>
                                                                </tr>
                                                            ))}

                                                        {loading && (
                                                            <tr>
                                                                <td colSpan={5} className="text-center">
                                                                    Loading...
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {!loading && userData.length === 0 && (
                                                            <tr>
                                                                <td colSpan={5} className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* PAGINATION FOOTER */}
                                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    <span>
                                                        Page{" "}
                                                        <strong>
                                                            {currentStart + 1} of {totalPages}
                                                        </strong>
                                                    </span>
                                                </div>
                                                <div className="dataTables_paginate paging_simple_numbers">
                                                    <Link
                                                        className={`paginate_button previous ${page === 0 ? "disabled" : ""
                                                            }`}
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (page > 0) setPage(page - 1);
                                                        }}
                                                    >
                                                        Previous
                                                    </Link>

                                                    <Link
                                                        className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                                                            }`}
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (page + 1 < totalPages) setPage(page + 1);
                                                        }}
                                                    >
                                                        Next
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </Tab.Container>
            </Row>
        </>
    );
};

export default SessionReports;
